// extracted by mini-css-extract-plugin
module.exports = {"errorsHazzard1":"styles_errorsHazzard1__3LCvm"};